import { Component, EventEmitter, input, Output } from '@angular/core';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  standalone: true,
  imports: [],
})
export class MenuItemComponent {
  readonly label = input<string>();
  readonly icon = input<string>();
  readonly disabled = input<boolean>();
  readonly showDivider = input<boolean>(false);
  readonly active = input<boolean>();
  readonly url = input<string>();
  @Output() readonly action = new EventEmitter();
}
